import * as React from 'react';
import Svg, { SvgProps, Circle, Path } from 'react-native-svg';

const DeleteIcon40 = (props: SvgProps) => (
  <Svg
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <Circle cx={20} cy={20} r={20} fill="#ED364C" />
    <Path
      fill="#fff"
      fillRule="evenodd"
      d="M20 12.083c.691 0 1.25.56 1.25 1.25v8.334a1.25 1.25 0 0 1-2.5 0v-8.334c0-.69.56-1.25 1.25-1.25Z"
      clipRule="evenodd"
    />
    <Path
      fill="#fff"
      d="M21.667 26.667a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"
    />
  </Svg>
);
export default DeleteIcon40;
